import { Ellipsis } from 'lucide-react';
import { FeatureFlag } from 'src/constants/feature-flag';

export type NavItem = {
  title: string;
  url: string;
  subUrls?: string[];
  openInNewTab?: boolean;
  onClick?: () => void;
  // If set, the item renders as a button that calls this handler instead of
  // navigating. `url` is still required for the active-route check.
  onActivate?: () => void;
  featureFlag?: string | ((flags: Record<string, boolean>) => boolean);
};

export type NavGroup = {
  title: string;
  icon: React.ComponentType;
  items: NavItem[];
  featureFlag?: string | ((flags: Record<string, boolean>) => boolean);
};

export const ADMIN_NAV_GROUP: NavGroup = {
  title: 'Admin',
  icon: Ellipsis,
  items: [
    {
      title: 'Investments',
      url: '/internal/admin/investments/general-config',
    },
    {
      title: 'Marketing Tools',
      url: '/internal/admin/marketing',
    },
    {
      title: 'Login as an Advisor',
      url: '/internal/admin/login-as-advisor',
    },
    {
      title: 'Manage Advisor Levels',
      url: '/internal/admin/grant-advisor-permissions',
    },
    {
      title: 'Export Client Info',
      url: '/internal/admin/ops/export-client-info',
    },
    {
      title: 'Export Service Calendar',
      url: '/internal/admin/ops/export-service-calendar',
    },
    {
      title: 'Upload from Orion to Box',
      url: '/internal/admin/ops/upload-from-orion-to-box',
    },
    {
      title: 'Advisor-led onboarding',
      url: '/internal/admin/ops/advisor-led-onboarding',
    },
    {
      title: 'Advisor organizations',
      url: '/internal/admin/organizations',
    },
    {
      title: 'Bulk Household Upload',
      url: '/internal/admin/ops/bulk-household-upload',
    },
    {
      title: 'Bulk Imports',
      url: '/internal/admin/ops/bulk-imports',
    },
    {
      title: 'Bulk Trades Upload',
      url: '/internal/admin/ops/bulk-trades-upload',
    },
    {
      title: 'Extract Data from Box Documents',
      url: '/internal/admin/ops/extract-household-documents',
    },
    {
      title: 'Bulk Onboarding Upload',
      url: '/internal/admin/ops/bulk-onboarding-upload',
    },
    {
      title: 'Advisor Book Upload',
      url: '/internal/admin/ops/advisor-book-upload',
      featureFlag: FeatureFlag.AdvisorOnboarding,
    },
    {
      title: 'Linked Bank Accounts',
      url: '/internal/admin/ops/linked-account-upload',
    },
    {
      title: 'Generate Quarterly Reports',
      url: '/internal/admin/ops/generate-quarterly-reports',
    },
    {
      title: 'NFS Audit Log',
      url: '/internal/admin/ops/nfs-audit-logs',
    },
    {
      title: 'NFS Audit Search',
      url: '/internal/admin/ops/nfs-audit-search',
    },
  ],
};
